import { render, staticRenderFns } from "./PlantVariety.vue?vue&type=template&id=232b10c2&"
import script from "./PlantVariety.vue?vue&type=script&lang=js&"
export * from "./PlantVariety.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports